<div class="tw-relative tw-overflow-hidden">
  <button
    type="button"
    mat-icon-button
    class="alerts-upgrade-modal-close tw-absolute tw-top-2 tw-right-2 lg:!tw-top-4 lg:!tw-right-4 tw-w-10 tw-h-10 lg:!tw-w-14 lg:!tw-h-14 tw-z-[2] tw-p-0 tw-bg-black/10 tw-rounded-lg"
    (click)="close()"
    aria-label="Close"
  >
    <mat-icon svgIcon="close" class="medium"></mat-icon>
  </button>

  <div class="tw-flex tw-flex-col lg:!tw-flex-row">
    <!-- Art image — top on mobile, right side on desktop -->
    <div
      class="tw-hidden lg:!tw-block lg:!tw-h-auto lg:!tw-w-1/2 tw-flex-none tw-flex tw-items-center tw-justify-center tw-relative tw-overflow-hidden"
    >
      <img
        src="/images/alerts-upgrade-modal-art.png"
        alt="Alerts upgrade modal illustration"
        class="tw-w-full tw-h-full tw-object-fill tw-relative tw-z-[1]"
      />
    </div>

    <!-- Text content -->
    <div
      class="lg:!tw-w-1/2 tw-py-12 tw-px-12 md:!tw-py-[100px] md:!tw-px-[52px] tw-flex tw-flex-col tw-justify-center lg:!tw-order-first"
    >
      <div
        class="alerts-upgrade-modal-badge tw-flex tw-items-center tw-gap-2 tw-mb-[24px]"
      >
        <mat-icon
          svgIcon="requires-upgrade"
          class="alerts-upgrade-modal-badge-icon small"
        ></mat-icon>
        <span class="tw-text-[14px] tw-text-gray-400 tw-font-bold">
          Unlock CAP Alerts with
          <strong class="tw-text-black tw-text-[14px]">Advanced Plan</strong>
        </span>
      </div>

      <h2
        class="alerts-upgrade-modal-title tw-text-[24px] tw-font-bold tw-m-0 tw-mb-[24px] tw-leading-none tw-leading-[29px]"
      >
        Emergency Alerts From A Service That Supports CAP
      </h2>

      <p
        class="alerts-upgrade-modal-body tw-text-[14px] tw-leading-relaxed tw-m-0 tw-mb-[24px] !tw-leading-[20px]"
      >
        Recognizing that school safety is of utmost importance, Rise Vision has
        developed and launched a new feature built to communicate emergency
        alerts and crucial information quickly.
      </p>

      <div
        class="tw-flex tw-flex-col sm:!tw-flex-row tw-items-stretch sm:!tw-items-center tw-gap-[8px]"
      >
        <button matButton="outlined" (click)="openLearnMorePage()">
          Learn More
        </button>
        <button
          mat-flat-button
          color="primary"
          class="!tw-rounded-lg tw-h-16 tw-font-medium tw-text-[14px] sm:!tw-min-w-[180px]"
          (click)="upgrade()"
        >
          {{ primaryButtonLabel }}
        </button>
      </div>
    </div>
  </div>
</div>
